/** "Calibration" icon (two sliders) for the top bar's calibration panel button. */
export function CalibrationIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
      <circle cx="13" cy="7" r="2.2" />
      <circle cx="9" cy="17" r="2.2" />
    </svg>
  );
}
